import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import { Accordion, AccordionTab } from 'primereact/accordion';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../FireBase/firestore";
import { useParams } from "react-router-dom";

const Orders = () => {
    const [orderData, setOrderData] = useState(null);
    const { orderId } = useParams();
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const docRef = doc(db, "orders", orderId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setOrderData(docSnap.data());
                }
            } catch (error) {
                console.error("Error fetching order:", error);
            }
        };
        fetchOrders();

    }, [orderId]);
    const cart = orderData?.cartItems || {};
    const items = cart.items || [];
    const getStatusConfig = (status) => {
        switch (status) {
            case "Pending":
                return { severity: "warning", icon: "pi pi-clock" };
            case "Confirmed":
                return { severity: "success", icon: "pi pi-check-circle" };
            case "Cancelled":
                return { severity: "danger", icon: "pi pi-times-circle" };
            default:
                return { severity: "info", icon: "pi pi-info-circle" };
        }
    };
    const statusConfig = getStatusConfig(orderData?.status);

    return (
        <>
            <div className="container mt-5">
                <NavBar />
                <div className="custom-top-padding">
                    {orderData ? (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h3 className='fw-bold text-black'>Order #{orderData.orderId}</h3>
                                <Tag value={orderData?.status} severity={statusConfig.severity} icon={statusConfig.icon}/>
                            </div>
                            <Accordion activeIndex={0}>
                                <AccordionTab header="Order Summary">
                                    <div style={{ background: '#f9f9f9', padding: '24px', borderRadius: '10px', margin: 'auto' }}>
                                        {items.map((item, idx) => (
                                            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ position: 'relative', marginRight: '10px' }}>
                                                        <img src={item.productImage} alt={item.productName} style={{ width: '60px', height: '60px', borderRadius: '5px', objectFit: 'cover' }} loading="lazy"/>
                                                        <span style={{position: 'absolute', top: '-8px', left: '-8px', backgroundColor: '#444', color: '#fff', borderRadius: '50%', width: '22px', height: '22px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{item.productQuantity}</span>
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 'bold' }}>{item.productName}</div>
                                                        <div style={{ fontSize: '13px', color: '#777' }}>
                                                            {item.productColor} / {item.productSize}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ fontWeight: 500 }}>{item.productTotal}</div>
                                            </div>
                                        ))}
                                        <div style={{ fontSize: '14px', marginTop: '20px' }}>
                                            <div className="d-flex justify-content-between">
                                                <span>Subtotal · {items.reduce((acc, item) => acc + item.productQuantity, 0)} items</span>
                                                <span>Rs.{cart.formattedSubtotal}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                                                <span>Shipping</span>
                                                <span>{cart.shipping}</span>
                                            </div>
                                            <hr style={{ margin: '12px 0' }} />
                                            <div className="d-flex justify-content-end fs-18 fw-bold">
                                                <div>
                                                    <span className='fs-13' style={{ color: '#888'}}>PKR</span>{' '}
                                                    <span>Rs {cart.formattedTotal}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionTab>
                            </Accordion>
                            <Divider />
                            <Card>
                                <h4 className='fw-bold text-black custom-fs-15-cart-details'>Contact Information</h4>
                                <p>{orderData.contact}</p>
                                <h4 className='fw-bold text-black custom-fs-15-cart-details'>Shipping Address</h4>
                                <p>
                                    {orderData.firstName} {orderData.lastName}
                                    <br />
                                    {orderData.address}
                                    <br />
                                    {orderData.city}
                                    <br />
                                    {orderData.selectedCountry}
                                    <br />
                                    {orderData.phone}
                                </p>
                                <h4 className='fw-bold text-black custom-fs-15-cart-details'>Billing Address</h4>
                                <p>
                                    {orderData.billingAddress === "SameAsShipping"
                                        ? "Same As Shipping Address"
                                        :
                                        <>
                                            {orderData.firstName} {orderData.lastName}
                                            <br />
                                            {orderData.address}
                                            <br />
                                            {orderData.city}
                                            <br />
                                            {orderData.selectedCountry}
                                            <br/>
                                            {orderData.phone}
                                        </>
                                    }
                                </p>
                                <h4 className="fw-bold text-black custom-fs-15-cart-details">Payment Method</h4>
                                <p>
                                    {orderData.paymentMethod === "COD"
                                        ? "Cash On Delivery (COD)"
                                        : "Bank Deposit"}
                                </p>
                                <h4 className="fw-bold text-black custom-fs-15-cart-details">Order Date</h4>
                                <p>
                                    {orderData?.createdAt?.toDate().toLocaleDateString("en-PK", {
                                        timeZone: "Asia/Karachi",
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric"
                                    })}
                                </p>
                            </Card>
                        </>
                    ) : (
                        <div className="text-center mt-5">
                            <h4>No Order Found</h4>
                        </div>
                    )}
                </div>
            </div>
            <Footer/>
        </>
    );
};
export default Orders;